// extracted by mini-css-extract-plugin
module.exports = {"input":"_2787e5dfdf--input--sakw_","button":"_2787e5dfdf--button--2D_8z"};